export default function simpleModal() {

  $(document).on('click', '.js-product-lk-open', (e) => {
    e.preventDefault();
    $('.js-product-lk-action').removeClass('is-active');
    const $btn = $(e.currentTarget);
    const $modal = $btn.parent('.js-product-thumb').find('.js-product-lk-action');
    $modal.addClass('is-active');
  });

  // click outside close
  $(document).on('click', (event) => {
    const $trigger = $('.js-product-lk-open');
    if ($trigger !== event.target && !$trigger.has(event.target).length && !$(event.target).closest('.js-product-lk-open').length) {
      $('.js-product-lk-action').removeClass('is-active');
    }
  });
}
